var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScribblesPeekSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 544,
    viewBox: "0 0 509 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.028 428.378C194.854 433.776 204.763 432.619 210.162 425.793C228.975 402.006 251.936 398.747 277.529 396.269C278.436 396.181 279.357 396.094 280.29 396.005C291.793 394.914 305.116 393.649 316.707 389.29C330.547 384.085 342.258 374.473 349.092 357.416C355.842 340.569 352.995 324.271 345.659 310.36C338.554 296.887 327.041 285.113 314.907 275.299C290.571 255.618 259.799 240.705 242.179 233.592C234.11 230.335 224.927 234.236 221.669 242.306C218.412 250.376 222.313 259.558 230.383 262.816C246.472 269.311 274.104 282.831 295.089 299.803C305.615 308.315 313.492 316.923 317.783 325.06C321.843 332.76 322.4 339.301 319.838 345.696C316.619 353.73 312.027 357.381 305.614 359.792C298.1 362.618 288.765 363.521 275.591 364.795C275.227 364.83 274.861 364.865 274.492 364.901C248.391 367.429 213.073 371.311 185.444 406.244C180.045 413.07 181.202 422.979 188.028 428.378Z",
    fill: "url(#paint0_linear_1381_51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.827 271.848C272.477 273.122 274.068 274.013 274.972 273.049L288.296 258.83C288.858 258.23 288.708 257.261 287.99 256.86L279.823 252.287C279.105 251.885 278.201 252.263 277.983 253.057L272.827 271.848Z",
    fill: "#52527C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M317.72 305.551C316.831 306.539 317.871 308.055 319.114 307.581L337.053 300.73C337.864 300.421 338.13 299.406 337.576 298.738L331.923 291.93C331.43 291.336 330.524 291.318 330.008 291.892L317.72 305.551Z",
    fill: "#52527C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M327.014 356.901C325.792 356.378 324.692 357.851 325.542 358.874L337.807 373.65C338.361 374.318 339.408 374.243 339.861 373.503L344.485 365.958C344.888 365.3 344.614 364.436 343.904 364.132L327.014 356.901Z",
    fill: "#52527C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4 377.325C278.126 376.024 276.288 375.971 275.939 377.254L270.9 395.784C270.673 396.622 271.336 397.435 272.202 397.381L281.033 396.827C281.804 396.778 282.352 396.057 282.193 395.301L278.4 377.325Z",
    fill: "#52527C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.258 389.753C221.344 388.788 219.75 389.704 220.124 390.98L225.53 409.407C225.774 410.24 226.764 410.586 227.474 410.086L234.709 404.992C235.341 404.547 235.43 403.645 234.899 403.085L222.258 389.753Z",
    fill: "#52527C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.733 279.584C303.74 278.729 305.22 279.796 304.727 281.022L297.461 299.102C297.154 299.866 296.212 300.139 295.545 299.657L287.952 294.183C287.285 293.702 287.246 292.722 287.873 292.19L302.733 279.584Z",
    fill: "#52527C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M341.194 331.029C342.509 331.164 342.764 332.97 341.538 333.463L323.463 340.743C322.7 341.051 321.851 340.56 321.736 339.746L320.427 330.477C320.312 329.663 320.992 328.956 321.81 329.04L341.194 331.029Z",
    fill: "#52527C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309.033 380.774C309.12 382.093 307.382 382.647 306.69 381.521L296.487 364.92C296.056 364.22 296.397 363.301 297.181 363.051L306.099 360.208C306.883 359.958 307.693 360.51 307.748 361.331L309.033 380.774Z",
    fill: "#52527C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.177 389.376C252.162 390.698 250.386 391.116 249.783 389.94L240.893 372.6C240.518 371.868 240.929 370.978 241.73 370.79L250.841 368.645C251.642 368.456 252.407 369.069 252.398 369.892L252.177 389.376Z",
    fill: "#52527C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.072 250.293L322.259 194.945C359.634 203.212 386.022 203.384 400.977 202.247L400.977 419.598C308.224 415.181 236.783 349.252 200.072 250.293Z",
    fill: "url(#paint1_linear_1381_51)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1381_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.676 238.01C374.867 236.669 348.749 252.993 346.847 273.995C344.945 294.997 367.98 312.725 382.789 314.066C397.599 315.407 400.191 289.302 401.943 275.358C403.195 265.399 404.486 239.351 389.676 238.01Z",
    fill: "#8C8CA1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1381_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.765 440.616C384.301 444.064 356.113 431.65 351.222 411.137C346.332 390.624 366.589 369.779 381.054 366.33C395.518 362.882 403.165 391.906 405.495 401.676C407.824 411.446 413.23 437.167 398.765 440.616Z",
    fill: "#8C8CA1"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.417 86.4195C257.771 88.7396 234.378 164.103 234.378 164.103C224.055 167.404 214.207 171.532 206.201 176.677C193.252 184.999 181.107 198.563 170.8 212.657C170.8 212.657 96.3347 216.275 93.9253 224.325C91.5159 232.375 142.762 270.819 142.762 270.819L192.175 327.732C224.828 351.982 307.563 323.977 307.563 323.977C307.563 323.977 360.031 258.912 348.783 221.803L307.139 157.495C307.139 157.495 275.063 84.0994 266.417 86.4195Z",
    fill: "url(#paint2_linear_1381_51)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242.062 272.82C249.31 278.928 237.11 278.696 231.002 285.944C224.894 293.191 227.19 305.175 219.942 299.067C212.694 292.959 215.707 285.449 221.816 278.201C227.924 270.954 234.814 266.712 242.062 272.82Z",
    fill: "#3D3D3D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M307.007 232.436C310.654 241.185 299.914 235.393 291.166 239.04C282.417 242.687 278.972 254.393 275.324 245.644C271.677 236.895 277.794 231.599 286.543 227.951C295.292 224.304 303.36 223.688 307.007 232.436Z",
    fill: "#3D3D3D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M282.909 294.261C285.034 294.909 287.206 293.399 287.337 291.181L288.328 274.471C288.497 271.61 285.294 269.814 282.941 271.45L265.94 283.276C263.587 284.912 264.158 288.541 266.899 289.377L282.909 294.261Z",
    fill: "#D8A5A5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M237.74 188.682C238.122 191.163 234.911 192.481 233.44 190.448L219.444 171.101C218.484 169.774 219.113 167.896 220.679 167.415L231.197 164.183C232.591 163.754 234.04 164.663 234.262 166.104L237.74 188.682Z",
    fill: "#52527C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.907 218.419C198.572 220.297 196.587 223.145 194.249 222.232L172.005 213.55C170.479 212.955 169.99 211.035 171.046 209.782L178.137 201.369C179.076 200.254 180.787 200.232 181.754 201.324L196.907 218.419Z",
    fill: "#52527C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239.153 238.358C241.143 239.839 243.793 237.684 242.749 235.434L214.87 175.318C214.335 174.163 212.991 173.633 211.825 174.145C208.504 175.603 201.953 178.672 197.605 181.956C193.211 185.276 187.479 191.529 184.691 194.68C183.776 195.714 183.958 197.296 185.065 198.12L239.153 238.358Z",
    fill: "#52527C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1381_51",
    x: 344.736,
    y: 237.933,
    width: 59.9132,
    height: 81.183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1381_51",
    x: 348.478,
    y: 366.047,
    width: 61.96,
    height: 80.1409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1381_51",
    x1: 186.139,
    y1: 426.883,
    x2: 306.805,
    y2: 360.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73738C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1381_51",
    x1: 428.142,
    y1: 362.719,
    x2: 256.269,
    y2: 329.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67677E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1381_51",
    x1: 188.381,
    y1: 181.626,
    x2: 315.25,
    y2: 326.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribblesPeekSide);
export default __webpack_public_path__ + "static/media/scribbles-peek-side.8e7545149104993746db153deaca78fa.svg";
export { ForwardRef as ReactComponent };